<template>
  <a-card title="发票模板" :bordered="false" :headStyle="{ fontSize: '18px' }">
    <div>
      <a-button type="primary" @click="goAddTemplate">添加发票模板</a-button>
    </div>
    <custom-page-table ref="table" rowKey="id" :columns="columns" :requestPromise="loadPromise">
      <span slot="action" slot-scope="rowItem">
        <a style="margin-right: 20px;" @click="edit(rowItem.record.id)">编辑</a>
        <a-popconfirm title="是否删除此模板?" @confirm="deleted(rowItem.record.id)">
          <a>删除</a>
        </a-popconfirm>
      </span>
    </custom-page-table>
  </a-card>
</template>

<script>
export default {
  name: 'InvoiceTemplate',
  data() {
    return {
      loadPromise: params => this.getRecordData(params),
      columns: [
        {
          title: '模板名称',
          dataIndex: 'templateName'
        },
        {
          title: '模板类型',
          dataIndex: 'templateTypeStr'
        },
        {
          title: '支持发票类型',
          dataIndex: 'supportTypeStr'
        },
        {
          title: '最后修改时间',
          dataIndex: 'updateTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  },
  mounted() {
  },
  methods: {
    deleted(id) {
      this.getHttpServices()
        .getUserService()
        .post('invoice/v2/deleteTemplate', { id: id })
        .then(res => {
          this.$message.success('成功删除')
          this.$refs.table.refresh(true)
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },
    goAddTemplate() {
      this.$router.push({
        name: 'AddInvoiceTemplate'
      })
    },
    edit(id) {
      this.$router.push({
        name: 'AddInvoiceTemplate',
        query: {
          id: id
        }
      })
    },
    getRecordData(params) {
      return this.getHttpServices()
        .getUserService()
        .post('invoice/v2/getTemplateList', params)
    }
  }
}
</script>
<style scoped>
</style>